// src/pages/NegotiationReview/ReviewFooter.jsx
import React from 'react';
import { FaBuilding, FaHashtag } from 'react-icons/fa';

const ReviewFooter = ({ negotiationData }) => {
  return (
    <footer className="review-footer">
      <div className="review-footer-container">
        <div className="review-footer-left">
          <p className="review-footer-copyright">
            © {new Date().getFullYear()} docusafe.ai All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ReviewFooter;
